import blenderIcon from "../img/Icons/Logos/BlenderLogo.png";

export default function BlenderSkill() {
    return (
        <div className="skillTile">
            <img src={blenderIcon} alt="csharp"/>
            <div className="skillTexts">
                <h2>Blender</h2>
            </div>
        </div>
    )
}